import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import Fade from '@material-ui/core/Fade';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';

export default function TicketsHistoricRow(props) {
  const { labelId, row, classes } = props;
  const { t } = useTranslation();

  function handleClick(selectedRow) {
    props.handleClick(selectedRow);
  }
  return (
    <TableRow
      className={classes.row}
      hover
      onClick={() => handleClick(row)}
      role="checkbox"
      tabIndex={-1}
    >
      <TableCell
        component="th"
        id={labelId}
        className={classes.tableCell}
        scope="row"
      >
        {row.ticketNumber}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {row.ticketCreationDate}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {row.ticketClosingDate}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {t(row.plannedType)}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {t(row.ticketStatus)}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {t(row.siteConcerned)}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {t(row.wagonStatus)}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {t(row.loadedStatus)}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {row.priority != null ? row.priority : '-'}
      </TableCell>
      <Tooltip TransitionComponent={Fade} title={row.damageDescriptions} arrow>
        <TableCell align="left" className={classes.tableCell}>
          {row.damageCodes}
        </TableCell>
      </Tooltip>
      <TableCell align="left" className={classes.tableCell}>
        {row.damagePlace}
      </TableCell>
    </TableRow>
  );
}
